<template>
    <div v-if="hasRecent" class="product__recent">
        <template v-if="!isLoading">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h3 class="pt-4 pb-6">Recently Viewed</h3>
                    </div>
                </div>
            </div>
            <div class="container" :class="{ 'px-0' :windowWidth <= 991 }">
                <div v-if="windowWidth <= 800" class="row mx-0">
                    <div class="col-12">
                        <slick ref="recentMobileSlider" :options="slickOptions" class="product__carousel">
                            <listing-product-item 
                                v-for="product in recentProducts" 
                                :key="product.id" 
                                :product="product"
                                :translations="translations"
                                :hideVariantSelector="true"
                                :class="`px-1`"
                            />
                        </slick>
                    </div>
                </div>

                <div v-else class="row">
                    <div class="col-12">
                    <slick :options="slickOptions" class="product__carousel">
                    <listing-product-item 
                        v-for="product in recentProducts" 
                        :key="product.id" 
                        :product="product"
                        :translations="translations"
                        :hideVariantSelector="true"
                        :class="`px-1`"
                    />
                    </slick>
                    </div>
                </div>
            </div>
        </template>
        <div v-else class="container">
            <div v-if="isLoading" class="text-center">
              <p class="lead" :data-products="recentProducts">Loading recent products</p>
              <div class="loading-animation">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Cookies from 'js-cookie';
import Slick from 'vue-slick';

import { storefrontRequestConfig } from '../utils/api'
import { transformProduct, multipleProductQuery }from '../utils/data'

import ListingProductItem from './listing-product-item.vue';


export default {
    name: 'ProductRecent',

    props: {
        productId: {
            type: String,
            default: ''
        },

        currencyIso: {
            type: String,
            default: 'USD'
        },
        
        translations: {
            type: Object
        }
    },

    components: {
        Slick,
        ListingProductItem
    },

    data: () => ({
        isLoading: true,
        recentProducts: [],
        hasRecent: false,
        windowWidth: window.innerWidth,
        slickOptions: {
            slidesToShow: 7,
            slidesToScroll: 1,
            rows: 0,
            dots: false,
            variableWidth: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 2,
                    }
                }
            ]
        }
    }),

    watch: {
        windowWidth(val) {
            if(val <= 1024) {
                setTimeout(() => {
                    this.$refs.recentMobileSlider.reSlick()
                }, 500)
            }
        }
    },

    computed: {
        recentIds() {
            return JSON.parse(Cookies.get('recently_viewed'))
        },

        filteredIds() {
            return this.recentIds.filter(id => id !== Number(this.productId))
        }
    },

    created() {
        window.addEventListener('resize', this.handleResize)
    },

    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },

    mounted() {
        if(this.filteredIds.length >= 1) {
            this.hasRecent = true
            this.fetchRecents()
        } else {
            this.hasRecent = false
        }
    },

    methods: {
        handleResize() {
            clearTimeout(this.resizeId)
            this.resizeId = setTimeout(() => {
                this.windowWidth = window.innerWidth      
            }, 500)
        },

        async fetchRecents() {
            this.isLoading = true

            const ids = this.filteredIds.map((id) => `"${btoa(`gid://shopify/Product/${id}`)}"`).reverse();
            const { data, status, statusText } = await axios.post(`https://${Shopify.shop}//api/graphql`, multipleProductQuery({currency: this.currencyIso, ids}), storefrontRequestConfig)

            if(status === 200) {
                let filteredData = data.data.nodes.filter(function (item) { return item != null; });

                this.recentProducts = filteredData.map(node => node ? transformProduct(node) : null)
                this.isLoading = false

            } else {
                this.isLoading = false
                alert(`Can't reach the server at this time. Please try again later`)
                console.log(statusText);
            }
        }
    }
}
</script>